module.exports = __webpack_public_path__ + "static/media/travel16.4ee0ee47.jpg";